module.exports = __webpack_public_path__ + "static/media/place1Icon.54568188.svg";